import { Injectable } from '@angular/core';
//import { ILogin } from './login';

//@Injectable({
//  providedIn: 'root'
//})

//@Injectable()
export class AuthService {
    

  constructor() { }

  logout(): void {
     console.log("logout called");
    localStorage.setItem('isLoggedIn', "false");
    localStorage.removeItem('token');
    localStorage.removeItem('push_token');
  } 

}



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/services/auth.service.ts